import { useEffect, useState } from "react";

// The visitor's self-selected stage from the "Where am I?" quiz, kept for the session so
// callback requests can carry it to the clinic.
const KEY = "lumiere_hair_stage";
const EVENT = "hair-stage";
const canStore = () => typeof window !== "undefined" && !!window.sessionStorage;

export const getHairStage = () => (canStore() ? window.sessionStorage.getItem(KEY) || "" : "");

export const setHairStage = (label) => {
  if (!canStore()) return;
  if (label) window.sessionStorage.setItem(KEY, label);
  else window.sessionStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVENT));
};

export const useHairStage = () => {
  const [stage, setStage] = useState(getHairStage);
  useEffect(() => {
    const sync = () => setStage(getHairStage());
    window.addEventListener(EVENT, sync);
    return () => window.removeEventListener(EVENT, sync);
  }, []);
  return [stage, setHairStage];
};

export const isHairPage = (path) => /^\/hair(\/|$)/.test(path || "");
